import React, { useEffect } from "react";
import Banner from "../components/home/Banner";
import WhyChoose from "../components/home/WhyChoose";
import TradeAssets from "../components/home/TradeAssets";
import TradingDesk from "../components/home/TradingDesk";
import Accounts from "../components/home/Accounts";
import TrustedAcross from "../components/home/TrustedAcross";
import GetStarted from "../components/home/GetStarted";
import CTA from "../components/home/CTA";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <WhyChoose />
      <TradeAssets />
      <TradingDesk />
      <Accounts />
      <TrustedAcross />
      <GetStarted />
      <CTA />
    </div>
  );
}

export default Home;
